<!-- Sidebar Navigation end-->
<div class="page-content">
  <!-- Page Header-->
  <div class="page-header no-margin-bottom">
    <div class="container-fluid">
      <h2 class="h5 no-margin-bottom">Transactions</h2>
    </div>
  </div>

  <section class="pt-20">
    <div class="container-fluid" *ngIf="transactions$ | async">
      <div class="public-user-block block" *ngFor="let item of transactions$ | async">
        <div class="row d-flex align-items-center">
          <div class="col-lg-4 d-flex align-items-center">
            <div class="order">{{ item.id }}</div>
          </div>
          <div class="col-lg-2 text-center">
            <div class="contributions">{{ item.amount }}</div>
          </div>
          <div class="col-lg-6">
            <div class="details d-flex">
              <div class="item w-50">
                <strong>{{ item.plan.title }}</strong>
              </div>
              <div class="item w-50">
                <strong>{{ item.created_at | date: 'dd MMM yy hh:mm' }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!(transactions$ | async).length">
      <div class="container-fluid">
        No transaction yet.
      </div>
    </ng-container>
  </section>
</div>
